import {
    Box,
    Button,
    Grid,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import InputBase from "@mui/material/InputBase";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import "../../../css/global.css"; // Importa el archivo global.css
import BreadcrumbBar from "../../../layout/BreadcrumbBar";
import getColumns from "../../../layout/Columns/ColumnsUsuarios";
import { TablePaginate } from "../../../layout/Datagrid/TablePaginate";
import { Icons } from "../../../layout/Icons";
import { queries } from "../../../queries";
import { catalogoList } from "../../../services/CatalogoServices";
import { rolType } from "../../../types/userTypes";
import { userRolEnum } from "../../../types/enumTypes";
import { Add, AddBox, LibraryAdd } from "@mui/icons-material";
import getColumnsMontosPF from "../../../layout/Columns/ColumnsMontosPF";
import getColumnsAcuerdosPF from "../../../layout/Columns/ColumnsAcuerdosPF";
import { mostrarDatosListaAcuerdos } from "../../../services/PpafeServices";
import { puedeCrear } from "../../../utils/permisosFlujo";

export interface fechaOrNull {
    fecha: string;
}

export default function AcuerdosPF() {
    const TITULO = "Participaciones Federales Acuerdos";
    const navigate = useNavigate();
    const [dataLoading, setDataLoading] = useState(false);
    const [currentPage, setCurrentPage] = React.useState(1);
    const [perPage, setPerPage] = React.useState(50);
    const [totalRows, setTotalRows] = React.useState(0);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [responseData, setResponseData] = useState<any[]>([]);
    const openSolicitud = () => {
        const url = `/admin/participaciones/federales/solicitudacuerdospf`;
        navigate(url);
    };
    const handleVerClick = (id: string, link: string) => {
        navigate("/" + link + "/alta/" + id);
    };

    const columns = getColumnsAcuerdosPF({ handleVerClick, urlOrigen: '/usuarios/listado', navigate });


    const ObtenerDatosLista = () => {
        const tipo = "participaciones"; // Aquí puedes cambiarlo dinámicamente
        const origen = "federales"; // También puedes pasarlo según la pantalla
        mostrarDatosListaAcuerdos(tipo, origen, setLoading, setResponseData, setError);
    };
    useEffect(() => {
        ObtenerDatosLista();
    }, []);


    return (
        <Grid container sx={{}}>
            <Grid sx={{}} item xs={12}>
                <BreadcrumbBar
                    links={[
                        { texto: "Inicio", link: "/admin" },
                        // { texto: "Configuración", link: "" },
                    ]}
                    Titulo={TITULO}
                />
            </Grid>
            <Grid container >
                <Grid item width={"100%"}>
                    <Typography
                        variant="h5"
                        component="div"
                        sx={{
                            flexGrow: 1,
                            fontWeight: "bold",
                            display: "flex",
                            justifyContent: "left",
                        }}
                    >
                        {TITULO}
                    </Typography>
                </Grid>
            </Grid>

            <Grid container>
                {
                    puedeCrear() &&
                    <Grid item xs={12} md={1} lg={2} mt={1}>
                        <Tooltip title="Buscar por fecha">
                            <Button
                                onClick={() => openSolicitud()}
                                sx={{ marginLeft: "5px", textTransform: "capitalize" }}
                                variant="contained"
                                size="small"
                            >
                                <Add /> Agregar
                            </Button>
                        </Tooltip>
                    </Grid>
                }

                <Grid
                    sx={{
                        justifyContent: "center",
                        paddingTop: "1px",
                        height: "8px",
                        display: "",
                    }}
                    item
                    xs={12}
                    md={12}
                    mt={2}
                ></Grid>
            </Grid>

            <TablePaginate
                rowsInfo={responseData}
                columns={columns}
                Mostrar={false}
                loading={dataLoading}
            />
        </Grid >
    );
}
